import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class MessageManager {

	constructor(messageElement, screenSize, performer, timingAmendment) {
		this.messageElement = messageElement;
		this.screenSize = screenSize;
		this.performer = performer;
		this.timingAmendment = timingAmendment;
		this.messageTimeout = [];
		this.reset();
	}

	setMessages(messages) {
		if (messages.length > 0) {
			this.reset();

			for (let message of messages) {
				let delay = parseInt(message.delay),
					text = message.$;

				this.messageTimeout.push(setTimeout(function () {
					this._showMessage(text);
				}.bind(this), parseInt(delay + this.timingAmendment)));
			}
		}
	}

	reset() {
		this._removeExistingMessage();
		this._clearMessageQueue();
	}

	_showMessage(message) {
		this._removeExistingMessage();

		let childNode,
			appendedElement;

		if (this.screenSize !== 'fullscreen') {
			if (message.match(/Chat startet/)) {
				childNode = helper.stringToHtml('<li class="message">' + message + '</li>');
			} else {
				childNode = helper.stringToHtml('<li class="message"><span class="schlampe">' + this.performer + '</span>' + message + '</li>');
			}

			appendedElement = document.getElementById(this.messageElement).appendChild(childNode);
			helper.fadeIn(appendedElement);
		} else {
			if (message.match(/Chat startet/)) {
				childNode = helper.stringToHtml('<div id="hostChat" class="chat hidden" >' + message + '</div>');
			} else {
				childNode = helper.stringToHtml('<div id="hostChat" class="chat hidden" ><span class="schlampe">' + this.performer + '</span>' + message + '</div>');
			}
			appendedElement = window.document.body.appendChild(childNode);
			helper.removeClass(appendedElement, 'hidden');
		}

		let host = appendedElement.querySelector('.schlampe');
		if (host !== null) {
			helper.addEventListener(host, 'click', function () {
				helper.triggerEvent(window, Events.HOST_CLICKED);
			});
		}
	}

	_removeExistingMessage() {
		helper.removeAll(document.querySelectorAll('li.message'));
		helper.remove(document.getElementById('hostChat'));
	}

	_clearMessageQueue() {
		for (let n = 0; n < this.messageTimeout.length; n++) {
			clearTimeout(this.messageTimeout[n]);
		}
		this.messageTimeout = [];
	}
}
